import { memo, useEffect } from "react"
import { access, logTimestamp, useParameter, useProperty } from "../../support/general"
import { cloneBlock, makeUniversalBlockKey, modelStore } from "../storage/model"
import $ from "jquery"
import { Cell, MetaCell, onStartRowDrag, TableColumn } from "./Column";
import { ensureSubscriptLoaded } from "./EPagedSubscript";
import { colWidthsStore, metaStore } from "./ENavigation";
import { getFieldDef, makeFieldCell, onMetaChanged } from "./Fields";
import { showMenu } from "../../support/popup";
import { changeBlockInfo, makeAndExecuteBlockRenameSubscript, makeAndExecuteBlockLevelUpdate, makeAndExecuteDeleteSubscriptUpdate, makeAndExecuteMoveUpdate, makeAndExecuteNewSubscriptUpdate, makeBlockLevelUpdate } from "../storage/changes";
import { Form } from "react-bootstrap";
import { showDialog } from "../../support/modal_dialog";
import { PlusMinus } from "../../support/UxBitsAndPieces";
import { dispatchUpdate } from "../storage/changes_admin";

export const Directory = memo(({scriptId,subscriptId,onSelectedSubscriptChanged})=>{

    var columns = modelStore.useSelector(state=>{
        return access (state,["model","Script",scriptId,"subscripts",subscriptId,"columns"]);
    });

    var content = <SubDirectory 
        scriptId={scriptId}
        subscriptId = {subscriptId} 
        indented = {0}
        onSelectedSubscriptChanged = {onSelectedSubscriptChanged}
        columns = {columns}
    />;

    return (<TableColumn
        label = "folder"
        key = "folder"
        scriptId = {scriptId}
        subscriptId = {subscriptId} 
        content = {content}
    />)

});

function SubDirectory({scriptId,subscriptId,indent,onSelectedSubscriptChanged,indented,columns}){
 
    useEffect(()=>{
        // console.log ("SubDirectory useEffect : "+subscriptId);
        ensureSubscriptLoaded( scriptId , subscriptId ); 
    },[]);

    // var columns = modelStore.useSelector(state=>{
    //     return access(state,["model","Script",scriptId,"directoryColumns"]);
    // });

    var totalWidth = 0;
   
    $.each(columns,(c,col)=>{
        totalWidth += col.width;
    })
    
    modelStore.useSelector(state=>{
        var latestVersionOfOrderedIds = access(state,["model","Script",scriptId,'subscripts',subscriptId,"orderedIds"]);
        return latestVersionOfOrderedIds;
    });

    var state = modelStore.state;
    
    var orderedIds = access(modelStore.state,["model","Script",scriptId,'subscripts',subscriptId,"orderedIds"]);

    var entryBlocks = [];

    if (orderedIds && columns) {
        
        $.each(orderedIds,(at,blockId)=>{
            
            entryBlocks.push(
                <EntryRow 
                    scriptId={scriptId}
                    subscriptId = {subscriptId} 
                    blockId={blockId} 
                    indent = {indent}
                    onSelectedSubscriptChanged = {onSelectedSubscriptChanged}
                    indented = {indented}
                    key = {blockId}
                    columns = {columns}
                />
            )

        });
   
    }

    return (<div 
        id = {"SubDirectory_"+subscriptId}
        style ={{
            width : totalWidth + 'px',
            height : '100%',
        }}
    >
        {entryBlocks}
    </div>)
}
export const EntryRow = memo(function ({scriptId,subscriptId,blockId,onSelectedSubscriptChanged,indented,columns}){

    var blockUid = makeUniversalBlockKey(scriptId,blockId);

    // logTimestamp("run EntryRow");

    var block = modelStore.useSelector(state=>{
            var block =  access(state,["model","Block",blockUid]);
            return block;
    })

    var isOpen = modelStore.useSelector(state=>{
        return !!access(block,['info','dirOpen']);
    })
    var subDirectoryElement = null;

    var cells = [];
    var totalWidth = 0;
    var text = ""
    // var isOpen = false;
    var uid = ""

    if (block && columns){
        
        var uid = makeUniversalBlockKey(scriptId,block.id);

        text = block.text;
        $.each(columns,(c,col)=>{
            totalWidth += col.width;

            var field = getFieldDef(modelStore.state,col.fieldId,subscriptId);
            cells.push(
                makeFieldCell(col,scriptId,subscriptId,field.type,block,indented,c,{onNavigationLink})
            );

        })

        //isOpen = !!access(block,['info','dirOpen']);

        if ( block.type =='directory' &&  block.reference && isOpen ) {
            subDirectoryElement = <SubDirectory 
                scriptId={scriptId} 
                subscriptId={block.reference} 
                onSelectedSubscriptChanged = {onSelectedSubscriptChanged}
                indented = {indented+1}
                columns = {columns}
            />
        }
    }

    function onNavigationLink(block){
        if (block){
            onSelectedSubscriptChanged(block.reference)
        }
    }

    var rowElement = <div
        id = "EntryRow"
        className="p-0 m-0 column-row"
        style={{
            textAlign:'left',
            padding : '0px',
            width : totalWidth+"px",            
        }}
        data-block-uid = {uid}
        data-is-open = {subDirectoryElement?"open":"closed"}
    >
        {cells}
    </div>

    if ( subDirectoryElement ) {
        return (<div>
            {rowElement}
            {subDirectoryElement}
        </div>)
    } else {
        return rowElement;
    }

});


export function EntryIdentifier({scriptId,subscriptId,col,block,onClick,indented}){



    indented = indented ? indented : 0 ;

    var text = block?block.text:"";

    function onToggleSubdirectory(){
        var newValue = !access(block,['info','dirOpen']);
        changeBlockInfo(scriptId,subscriptId,makeUniversalBlockKey(scriptId,block.id),'dirOpen',newValue);
    }

    var isOpen = modelStore.useSelector(state=>{
        var value =!!access(block,['info','dirOpen']);
        return value
    }) 

    var margin = null;
    if (block.type == 'directory'){
        margin = <PlusMinus isOpen={isOpen} onClick={onToggleSubdirectory} isVisible={true} />
    }

    function renameBlock(){

        var newName=text;

        showDialog({
            title : "Rename '"+ text + "'",
            message : { tag:Rename , props:{block,onNameChanged:name=>{newName=name}} },
            ok : true,
            onOk : ()=>{
                makeAndExecuteBlockRenameSubscript(scriptId,block.reference,block.id,{bits:{t:true},text:newName});
            },
            cancel : true
        })

        function Rename({block,onNameChanged}){
            const [getValue,setValue] = useProperty(block.text)

            function onChange(e){
                setValue(e.target.value);
                onNameChanged(getValue());
            }

            return (<input autoFocus  type="text" value={getValue()} onChange={onChange} />)
        }

    }

    function onContextMenu(e){
        // if (e.buttons==2){
            showMenu({at:{x:e.clientX,y:e.clientY},items:[
                {
                    name : 'New Script',
                    onClick : ()=>{makeNewSubscript(scriptId,'script',subscriptId,block)}
                },{
                    name : 'New Note',
                    onClick : ()=>{makeNewSubscript(scriptId,'note',subscriptId,block)}
                },{
                    name : 'New Wall',
                    onClick : ()=>{makeNewSubscript(scriptId,'wall',subscriptId,block)}
                },{
                    name : 'New Folder',
                    onClick : ()=>{makeNewSubscript(scriptId,'directory',subscriptId,block)}
                },{
                    name : 'Rename',
                    onClick : ()=>{renameBlock()}
                },{
                    name : 'Duplicate',
                    onClick : ()=>{duplicateSubscript(scriptId,block)}
                },{
                    name : 'Delete',
                    onClick : ()=>{deleteEntry(scriptId,subscriptId,block)}
                }
            ]})
            e.preventDefault();
            e.stopPropagation();                    
            return false;
        // }
    }

    function onMouseUp(e){
        e.preventDefault();
        e.stopPropagation();                    
        return false;
    }
    

    function onRowDrop(lastRowOver,lastRowOverTop){

        console.log ("End row drag : " + block.id);

        if (!lastRowOverTop && (lastRowOver.blockUid != makeUniversalBlockKey(scriptId,block.id))){

            var model = modelStore.state.model;

            var targetBlock = model.Block[lastRowOver.blockUid];

            if (block.type=='directory'){
                
                var ancestry = {};
                //var ssi = model.Script[scriptId].subscripts[targetBlock.subscriptId].parentSubscriptId;
                var ssi = targetBlock.subscriptId
                while (ssi){
                    ancestry[ssi] = true;
                    ssi = model.Script[scriptId].subscripts[ssi].parentSubscriptId;
                }
                if (ancestry[block.reference]){
                    console.log("can't move a directory into itself");
                    return;     
                }                
            }

            if (lastRowOver.isOpenSubdirectory == 'open') {
                // block is going into targetBlock's reference subscript as its fist member
                makeAndExecuteMoveUpdate(scriptId, block.id,targetBlock.reference,0);
            } else {
                // block is going into targetBlock's containing subscript just after targetBlock
                var at = modelStore.state.getBlockLocation(scriptId,targetBlock.subscriptId,makeUniversalBlockKey(scriptId,targetBlock.id));
                makeAndExecuteMoveUpdate(scriptId, block.id,targetBlock.subscriptId,at+1);
            }
        }

    }

    function onMouseMove(e){
        if (e.buttons==1){

            onStartRowDrag(e,makeUniversalBlockKey(scriptId,block.id),onRowDrop);
        }
    }

    function onDoubleClick(e){
        renameBlock();
    }


    var id = "Entry_"+ makeUniversalBlockKey(scriptId,block.id);
    var textLeft = ( indented+1.4) + 'em';


    return (
        <Cell
            id = {id}
            col={col}
            onClick = {onClick}
            key = {col.fieldId}
            className = "prevent-select "
            style = {{
                height: '2em',
                minHeight : '2em',
                overflow : 'hidden',
                cursor : 'pointer',
                textAlign : 'left',

            }}
        >
            <div
                id = "FieldName"
                style={{
                    position:'absolute',
                    height : '2em',
                    width : col.width+'px',
                    left : '0px',
                    top:'0px',
                    overflow:'hidden',
                    textAlign : 'left',
                }}
                // onMouseDown = {onMouseDown}
                onMouseMove = {onMouseMove}
                // onMouseUp = {onMouseUp}
                onContextMenu={onContextMenu}
                onDoubleClick = {onDoubleClick}
            >
                {margin}
                
                <div 
                    style={{
                        position : 'absolute',
                        left : textLeft,
                        width : '1000em',
                        textAlign : 'left',
                    }}
                >{text}</div>
            </div>

        </Cell>
    )
}
// function EntryTextInput({scriptId,block,onFinished,style}){

//     const [getValue,setValue] = useParameter(block.text);

//     useEffect(()=>{

//     },[])

//     function onChange(e){
//         setValue(e.target.value);
//     }
    
//     function commitEditAndFinish(){        
//         makeAndExecuteBlockContentChange(scriptId,block.subscriptId,block.id,{text:getValue()});
//         onFinished();
//     }

//     function onKeyDown(e){
//         if (e.key =="escape"){
//             onFinished();
//         } else if (e.key=='return') {
//             commitEditAndFinish();
//         }
//     }
//     style = $.extend({
//         backgroundColor : 'red'
//     },style);
//     return (
//         <input autoFocus  type="text" placeholder="text" value={getValue()} onChange={onChange} 
//             onKeyDown={onKeyDown}
//             onBlur={commitEditAndFinish}
//             style = {style}
//         /> 
//     )
// }
function deleteEntry (scriptId,parentSubscriptId,referenceBlock){
    
    showDialog({
        title : "Delete : '"+ referenceBlock.text+"'",
        message : 'Are you sure?',
        ok : 'Yes',
        onOk : ()=>{
            makeAndExecuteDeleteSubscriptUpdate(scriptId,parentSubscriptId,referenceBlock);
        },
        cancel : true
    })

}

function makeNewSubscript(scriptId,type,parentSubscriptId,referenceBlock){

    
    var afterBlockId = referenceBlock.id;
    if (referenceBlock.type=='directory'){
        parentSubscriptId = referenceBlock.reference;
        afterBlockId = 0;
    }

    var at = 0;
    if (afterBlockId){
        at = modelStore.state.getBlockPosition(scriptId,parentSubscriptId,afterBlockId)+1
    }
    
    makeAndExecuteNewSubscriptUpdate(scriptId,parentSubscriptId,{
        type,
        scriptId,
        parentSubscriptId,
        at : at,
        name : type,
    })

    
}


export function makeAndExecuteDuplicateSubscriptUpdate(scriptId,referenceBlock){
    
    dispatchUpdate(
        scriptId,
        referenceBlock.subscriptId,
        {
            executeDo : function (state,scriptId,subscriptId,dirty){
                var model = state.model;
                var script = model.Script[scriptId];
                var containerSubscript = script.subscripts[referenceBlock.subscriptId];
                var targetSubscript = script.subscripts[referenceBlock.reference]

                // create new subscript
                var newSubscriptId = script.nextSubscriptId++;
                script.subscripts[newSubscriptId] = {
                    id : newSubscriptId,
                    orderedIds : [],
                    pages : [[]],
                    name : referenceBlock.text+"_copy",
                    type : targetSubscript.type,
                    parentSubscriptId : containerSubscript.id,
                    columns : $.extend(true,{},{columns:targetSubscript.columns}).columns,
                    customFields : $.extend(true,{},targetSubscript.customFields)
                }

                dirty.add(scriptId,{
                    scriptChange : {
                        bits : {s:true},
                        script
                    }
                });

                var blocks = [];
                $.each(targetSubscript.orderedIds,(b,blockId)=>{
                    var block = model.Block[makeUniversalBlockKey(scriptId,blockId)];
                    var newBlock = cloneBlock(block);
                    newBlock.id=0;
                    newBlock.subscriptId = newSubscriptId;
                    blocks.push(newBlock);
                })
                
                state.insertBlock(scriptId,newSubscriptId,0,blocks,dirty);
    
                // create an entry for the new subscript in the folder tree 
                
                var entryAt = state.getBlockLocation(scriptId,containerSubscript.id,referenceBlock.id);

                state.insertBlock(scriptId,containerSubscript.id,entryAt,{
                    type : targetSubscript.type,
                    text : referenceBlock.text+"_copy",
                    meta : {},
                    reference : newSubscriptId,
                },dirty);

                var j = 4/0;

                return {
                    subscriptOrderInvalid : [],
                    navTreeInvalid : true,
                };
            }
        },    
   );



}

function duplicateSubscript(scriptId,referenceBlock){

    var model = modelStore.state.model;
    var script = model.Script[scriptId];
    var targetSubscript = script.subscripts[referenceBlock.reference]
    if (targetSubscript.type=='directory'){
        showDialog({title:"Error",message:"Can not duplicate directories",ok:'Close'});
    } else {
        ensureSubscriptLoaded(scriptId,referenceBlock.reference,()=>{
            makeAndExecuteDuplicateSubscriptUpdate(scriptId,referenceBlock)
        });
    }
}